import { render, staticRenderFns } from "./pdfList.vue?vue&type=template&id=a2418fc2&"
import script from "./pdfList.vue?vue&type=script&lang=js&"
export * from "./pdfList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports